var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "url(#paint0_linear_12700_33690)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M15.7513 9.97911L8.84249 3.07031H7.04908V3.86071C5.67743 4.10599 4.86969 4.95153 4.86969 6.25476C4.86969 6.95982 5.09004 7.4467 5.42764 7.79543L7.04117 9.40897H4.76172C4.76172 10.1888 5.02153 10.8269 5.48742 11.2923L9.95404 15.7589C11.3507 15.4056 12.6262 14.6823 13.6464 13.6652C14.6666 12.648 15.3938 11.3747 15.7513 9.97911Z",
    fill: "url(#paint1_linear_12700_33690)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92703 12.0888V12.93H7.13362V12.0937C5.67142 11.827 4.76562 10.8651 4.76562 9.4089H7.06054C7.06054 9.95217 7.50454 10.2235 8.00134 10.2235C8.46722 10.2235 8.91119 9.98638 8.91119 9.57223C8.91119 9.06932 8.28828 8.92353 7.52454 8.73476C6.35839 8.44497 4.87359 8.08494 4.87359 6.25476C4.87359 4.95153 5.68134 4.10599 7.05298 3.86071V3.07031H8.84639V3.86894C10.2096 4.13486 10.9781 5.03319 10.9781 6.37038L8.74966 6.3754C8.74966 5.90417 8.3726 5.67399 7.91183 5.67399C7.51151 5.67399 7.12931 5.83876 7.12931 6.18599C7.12931 6.64609 7.73337 6.7969 8.49839 6.99086C9.68674 7.29767 11.2385 7.68686 11.2385 9.52791C11.2384 10.9653 10.3102 11.8325 8.92703 12.0888Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12700_33690",
    x1: 0,
    y1: 8,
    x2: 16,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00AEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12700_33690",
    x1: 5.04357,
    y1: 5.05994,
    x2: 13.6476,
    y2: 13.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.af8ea1b681881b74ce7def0086478deb.svg";
export { ForwardRef as ReactComponent };